import React, {Fragment} from 'react';
import Select from './../Select';
import isEqual from 'lodash-es/isEqual';
import TextInput from "../TextInput";
import {loadComponentById} from "../../../utils/components";
import Button from "../Button";
import classNames from 'classnames';
import {postData} from "../../../utils/request";
import {AddressFormatter, LocationSelect} from "../../../utils/formatters";
import {debounce} from "lodash-es";

let furgefutarpoints = null;

class FurgeFutarPointControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            furgefutarpoints: furgefutarpoints,
            point: props.value.point || null,
            linkContact: this.props.linkContact
        };
        this.loadContact = debounce((partner_id) => {
            this.loadContactRequest && this.loadContactRequest.abort();
            this.loadContactRequest = loadComponentById("partner", partner_id, ["name", "email", "telnum"]);
            this.loadContactRequest.then((customer) => {
                this.setFieldValue("contact", customer.name);
                this.setFieldValue("email", customer.email);
                this.setFieldValue("telnum", customer.telnum);
            });
        }, 300);
    }

    componentDidMount() {
        if (!this.state.furgefutarpoints) {
            this.initLayoutData();
        } else {
            this.setLayoutValues(this.state);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(this.props.value.point, prevProps.value.point) || this.props.linkContact !== prevProps.linkContact) {
            this.setState({
                point: this.props.value.point || null,
                linkContact: this.props.linkContact
            })
        }
        if (this.state.linkContact !== prevState.linkContact) {
            this.initValues();
        } else if (!isEqual(this.props.client, prevProps.client)) {
            this.initValues();
        }
    }

    initValues = () => {
        if (this.getProps('').disabled) return;
        if (this.props.autoFill !== false && this.state.linkContact !== false) {
            this.loadContact && this.loadContact.cancel();
            const partner_id = this.props.client.values.customer instanceof Object ? this.props.client.values.customer.partner_id : this.props.client.values.customer;
            if (partner_id) {
                this.loadContact(partner_id);
            }
        }
    }

    componentWillUnmount() {
        this.lastrequest && this.lastrequest.abort();
    }

    initLayoutData = () => {
        this.setState({isLoading: true}, () => {
            this.lastrequest && this.lastrequest.abort();
            this.lastrequest = postData({action: "furgefutarpoint.getPoints", resptype: "json"});
            this.lastrequest.then((response) => {
                let state = {...this.state, isLoading: false};
                state.furgefutarpoints = response.data;
                furgefutarpoints = JSON.parse(JSON.stringify(response.data));
                this.setLayoutValues(state);
            });
            this.lastrequest.catch(() => {
                this.setState({isLoading: false});
            });
        });
    }

    setLayoutValues = (state) => {
        let selectedPoint = state.point || null;
        let selectedCity = state.city || null;
        if (selectedPoint != null) {
            Object.keys(state.furgefutarpoints).map((city) => {
                Object.keys(state.furgefutarpoints[city] || {}).map((store) => {
                    if (selectedPoint + "" === "" + store) {
                        selectedCity = city;
                    }
                });
            });
        }
        state.city = selectedCity;
        this.setState(state);
    }

    setFieldValue = (field, value) => {
        this.setState({point: value}, () => {
            this.props.saveChanges && this.props.saveChanges(field, value);
        });
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        const currentfurgefutarpoints = this.state.furgefutarpoints || {};
        let selectedPoint = this.state.point || null;
        let selectedCity = this.state.city || null;
        let cities = Object.keys(currentfurgefutarpoints).map((key) => {
            return {value: key, label: key};
        });
        let exists = false;
        let stores = Object.keys(currentfurgefutarpoints[selectedCity] || {}).map((key) => {
            let point = currentfurgefutarpoints[selectedCity][key];
            if (key + "" === "" + selectedPoint) {
                exists = true;
            }
            return {...point, value: key, label: point.Name + " (" + point.PostCode + ", " + point.City + " " + point.Street + ")"};
        });

        const contactProps = this.getProps("contact");
        const emailProps = this.getProps("email");
        const telnumProps = this.getProps("telnum");

        return {
            ...this.props.fields,
            contact: <div className="col-md-12">
                <TextInput
                    {...contactProps}
                    name="contact"
                    required={true}
                    label="Címzett"
                    value={this.props.value && this.props.value.contact}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || contactProps.disabled}
                />
            </div>,
            email: <div className="col-md-12">
                <TextInput
                    {...emailProps}
                    name="email"
                    required={true}
                    label="Email"
                    value={this.props.value && this.props.value.email}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || emailProps.disabled}
                />
            </div>,
            telnum: <div className="col-md-12">
                <TextInput
                    {...telnumProps}
                    name="telnum"
                    required={true}
                    label="Telefon"
                    value={this.props.value && this.props.value.telnum}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || telnumProps.disabled}
                />
            </div>,
            autoInfo: <div className="col-md-12">
                <label className="control-label">&nbsp;</label>
                <Button
                    icon={{lib: "fas", name: this.state.linkContact !== false ? "link" : "unlink"}}
                    block={true}
                    color={this.state.linkContact !== false ? "primary" : "default"}
                    tooltip={"Autómatikus kitöltés " + (this.state.linkContact !== false ? "bekapcsolva" : "kikapcsolva")}
                    onClick={() => {
                        this.setState({linkContact: !(this.state.linkContact !== false)});
                    }}
                />
            </div>,
            postcode: null,
            city: <div key={3} className="col-sm-6">
                <Select
                    {...this.getProps("point")}
                    options={cities}
                    objectValue={false}
                    required={true}
                    storeType="local"
                    label="Kerület vagy Település"
                    isLoading={this.state.isLoading}
                    saveChanges={(field, value) => this.setState({
                        point: null,
                        city: value
                    })}
                    value={selectedCity}
                    valueKey="value"
                    labelKey="label"
                />
            </div>,
            address: <div key={4} className="col-sm-6">
                <Select
                    {...this.getProps("point")}
                    options={stores}
                    objectValue={false}
                    required={true}
                    storeType="local"
                    label="Átvevőpont"
                    optionsTemplate={(props) => {
                        return <LocationSelect {...{name: props.Name, address: {postcode: props.PostCode, city: props.City, address: props.Street}}} />;
                    }}
                    isLoading={this.state.isLoading}
                    saveChanges={(field, value) => this.setFieldValue("point", value)}
                    value={selectedPoint}
                    valueKey="value"
                    labelKey="label"
                    error={!exists && !!selectedPoint ? "A kiválaszott átveteli pont jelenleg nem elérhető!" : null}
                />
            </div>
        };
    }

    getLayout = () => {
        const fields = this.getFields();
        return <Fragment>{fields.postcode}{fields.city}{fields.address}</Fragment>;
    }

    render() {
        return this.props.layout ? this.props.layout(this.getFields()) : this.getLayout();
    }

}

export default FurgeFutarPointControl;